var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';
// https://github.com/resolutionlife/resre/blob/master/packages/go/errs/errors.go#L19
var ServerErrorCode;
(function (ServerErrorCode) {
    ServerErrorCode["OTHER"] = "OTHER";
    ServerErrorCode["BAD_REQUEST"] = "BAD_REQUEST";
    ServerErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ServerErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    ServerErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ServerErrorCode["TEMPORARY"] = "TEMPORARY";
})(ServerErrorCode || (ServerErrorCode = {}));
export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    const tags = {
        operationName: operation.operationName,
    };
    if (graphQLErrors) {
        graphQLErrors.forEach((_a) => {
            var { message, path } = _a, rest = __rest(_a, ["message", "path"]);
            const extensions = rest.extensions;
            const error = `[GraphQL error]: ${message}`;
            const gqlError = JSON.stringify({ path, extensions });
            const captureContext = {
                contexts: {
                    error: { body: gqlError },
                },
                tags: Object.assign(Object.assign({}, tags), { gql_error_code: extensions === null || extensions === void 0 ? void 0 : extensions.code }),
            };
            switch (extensions === null || extensions === void 0 ? void 0 : extensions.code) {
                // Error codes included in this case will only trigger a warning
                case ServerErrorCode.BAD_REQUEST: {
                    Sentry.captureMessage(error, Object.assign(Object.assign({}, captureContext), { level: 'warning' }));
                    return;
                }
                default: {
                    Sentry.captureMessage(error, Object.assign(Object.assign({}, captureContext), { level: 'error' }));
                }
            }
        });
    }
    if (networkError) {
        if (isServerError(networkError)) {
            const warnings = [401];
            // If the error is a 401, downgrade this to a warning because
            // it's often an expired token from a long polling process
            const level = warnings.includes(networkError.statusCode)
                ? 'warning'
                : 'error';
            Sentry.captureException(`[Network error]: ${networkError}`, {
                tags: Object.assign(Object.assign({}, tags), { statusCode: networkError.statusCode }),
                level,
            });
        }
        else {
            Sentry.captureException(`[Network error]: ${networkError}`, {
                tags,
                level: 'error',
            });
        }
    }
});
const isServerError = (networkError) => {
    if (!networkError)
        return false;
    return 'statusCode' in networkError && 'result' in networkError;
};
